import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SETTINGS_HEADER_SCHEMA = Object.freeze({
  UPDATED_TIME: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  SCHEMA_VERSION: '',
});
export const RECORD = generateSchema(SETTINGS_HEADER_SCHEMA);
export const KEYS: any = generateKeys(SETTINGS_HEADER_SCHEMA);

export class SettingsHeader extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
